import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, ButtonGroup, Card, Col, Form, Modal, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo, faWindowClose} from "@fortawesome/free-solid-svg-icons";
import TextInput from "./input/TextInput";
import TextAreaInput from "./input/TextAreaInput";
import {withRouter} from 'react-router-dom';
import GoodsCategorySelectorModal from "./GoodsCategorySelectorModal";
import NumberInput from "./input/NumberInput";
import ItemOption from "./input/ItemOption";
import {navigate} from "enqc-utilities/src/utils/Utilities";
import GoodsInfoDetailPage from "../pages/goods/GoodsInfoDetailPage";


const maxBorrowingDurationOptions = [{id:1, label:label.NotLimited}, {id:2, label:label.Limited}];
class GoodsInfoViewModal extends BaseComponent{

    constructor(props) {
        super(props);
        let {show, goodsInfo} = this.props
        if(!goodsInfo){
            goodsInfo = {}
        }
        if(goodsInfo.borrowingDurationType===undefined){
            goodsInfo.borrowingDurationType = true
        }
        this.state = {
            show, goodsInfo
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!=this.props){
            let {show, goodsInfo} = this.props
            if(!goodsInfo){
                goodsInfo = {}
            }
            if(goodsInfo.borrowingDurationType===undefined){
                goodsInfo.borrowingDurationType = true
            }
            this.setState({goodsInfo, show}, () => {
                if(show){
                    // this.fetchGoodsCategories((goodsCategories)=>{
                    //     this.setState({goodsCategories})
                    // })
                }
            })
        }
    }

    render() {
        let {goodsInfo, show, categorySelectorModal} = this.state
        let goodsCategory = goodsInfo.goodsCategory?goodsInfo.goodsCategory:{}
        return (
            <>
                {super.render()}
                <GoodsCategorySelectorModal
                    show={categorySelectorModal}
                    goodsCategory={goodsCategory}
                    onClose={() => {
                        this.setState({categorySelectorModal:false})
                    }}
                    onSelectGoodsCategory={(goodsCategory) => {
                        goodsInfo.goodsCategory = goodsCategory
                        this.setState({goodsInfo, categorySelectorModal:false})
                    }}
                    showProcessing={this.props.showProcessing}
                    closeProcessing={this.props.closeProcessing}
                />
                <Modal as={Modal.Dialog} size="lg" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.GoodsInfoDetail}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-4">
                            <Col>
                                <Card border="light">
                                    <Row>
                                        <Col className="p-3">
                                            <Card.Img src={goodsInfo.image1?goodsInfo.imageLink1:ApplicationIcons.Icons.imagePlaceholder}/>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col>
                                <Card border="light">
                                    <Row>
                                        <Col className="p-3">
                                            <Card.Img src={goodsInfo.image2?goodsInfo.imageLink2:ApplicationIcons.Icons.imagePlaceholder}/>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col>
                                <Card border="light">
                                    <Row>
                                        <Col className="p-3">
                                            <Card.Img src={goodsInfo.image3?goodsInfo.imageLink3:ApplicationIcons.Icons.imagePlaceholder}/>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col>
                                <Card border="light">
                                    <Row>
                                        <Col className="p-3">
                                            <Card.Img src={goodsInfo.image3?goodsInfo.imageLink3:ApplicationIcons.Icons.imagePlaceholder}/>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form>
                                    <TextInput
                                        label={label.GoodsCategory}
                                        required={true}
                                        value={goodsCategory.name}
                                        placeholder={" "}
                                        disabled={true}
                                        readOnly={true}
                                        clickable={true}
                                    />
                                </Form>
                            </Col>
                            <Col md={6}>
                                <Row>
                                    <Col md={8}>
                                        <TextInput
                                            label={label.MaxBorrowingDuration}
                                            required={true}
                                            value={goodsInfo.borrowingDurationType===true?maxBorrowingDurationOptions[0].label:maxBorrowingDurationOptions[1].label}
                                            placeholder={" "}
                                            disabled={true}
                                            readOnly={true}
                                            clickable={true}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Row>
                                            <Col>
                                                <Form.Label>
                                                    {label.PerHour}
                                                </Form.Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <NumberInput
                                                    required={true}
                                                    value={goodsInfo.maximumBorrowingDurationInHour?goodsInfo.maximumBorrowingDurationInHour:0}
                                                    placeholder={" "}
                                                    clickable={true}
                                                    disabled={true}
                                                    readOnly={goodsInfo.borrowingDurationType}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form>
                                    <TextInput
                                        label={label.GoodsName}
                                        required={true}
                                        placeholder={label.EnterGoodsName}
                                        value={goodsInfo.name}
                                    />
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form>
                                    <TextAreaInput
                                        label={label.GoodsDescription}
                                        required={true}
                                        placeholder={label.EnterGoodsDescription}
                                        rows={4}
                                        value={goodsInfo.description}
                                    />
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-right px-4 pb-2">
                                <ButtonGroup>
                                    <Button
                                        size="sm"
                                        variant="success"
                                        onClick={(event) => {
                                            navigate(this.props, GoodsInfoDetailPage.ENDPOINT+"/"+goodsInfo.id)
                                        }}>
                                        {label.SeeAllItem}&nbsp;&nbsp;<FontAwesomeIcon icon={faInfo}/>
                                    </Button>
                                    &nbsp;&nbsp;&nbsp;
                                    <Button
                                        size="sm"
                                        variant="outline-warning"
                                        onClick={(event) => {
                                            this.props.onClose()
                                        }}>
                                        {label.Close}&nbsp;&nbsp;<FontAwesomeIcon icon={faWindowClose}/>
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
GoodsInfoViewModal.propTypes = {
    position:PropTypes.number,
    show:PropTypes.object.isRequired,
    goodsInfo:PropTypes.object,
    onClose:PropTypes.func.isRequired,
    onResult:PropTypes.func.isRequired

}

export default withRouter(GoodsInfoViewModal)
